import {
  QueryOptions,
  useGitFilePreview,
} from '../../queries/useGitFilePreview';

import { ArtifactFile } from './types';
import {
  UNKNOWN_DEPLOYMENT_TYPE,
  detectDeploymentType,
} from './detectDeploymentType';

export function useDetectDeploymentType(
  file: ArtifactFile,
  options?: QueryOptions
) {
  const { path, ref, sourceId } = file;
  const { data, ...mutationFields } = useGitFilePreview(
    {
      targetFile: path,
      reference: ref,
      sourceId,
    },
    options
  );

  return {
    ...mutationFields,
    data:
      !mutationFields.isLoading && !mutationFields.error && data
        ? detectDeploymentType(data, path)
        : UNKNOWN_DEPLOYMENT_TYPE,
  };
}
